import Echo from "laravel-echo";
import axios from "@/plugins/axios";
import errorHandler from '@/services/errorHandler';

import Pusher from 'pusher-js';
(window as any).Pusher = Pusher;

const instance = new Echo({
    broadcaster: 'reverb',
    key: process.env.VUE_APP_REVERB_APP_KEY,
    wsHost: process.env.VUE_APP_REVERB_HOST,
    wsPort: process.env.VUE_APP_REVERB_PORT,
    wssPort: process.env.VUE_APP_REVERB_PORT,
    forceTLS: (process.env.VUE_APP_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    //authEndpoint: '/api/broadcasting/auth',
    authorizer: (channel: any, options: any) => {
        return {
            authorize: (socketId: string, callback: any) => {
                axios.post('/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name
                })
                    .then((response: any) => {
                        // axios interceptor уже возвращает response.data, не AxiosResponse
                        callback(null, response);
                    })
                    .catch((error: any) => {
                        errorHandler.handle(error, { showDialog: false, logToConsole: false });
                        callback(error);
                    });
            }
        };
    },
    encrypted: true
});

(window as any).Echo = instance;
export default instance